import React from 'react';

const CasinoCard = ({ casino, rank }) => {
  // Track outbound clicks to betting sites
  const trackOutboundClick = (url, bookmakerName) => {
    if (window.trackOutboundClick) {
      window.trackOutboundClick(url, bookmakerName);
    }
    console.log(`Outbound click tracked: ${bookmakerName} -> ${url}`);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
      <div className="p-4">
        {/* Mobile Layout */}
        <div className="md:hidden">
          <div className="flex items-start space-x-4">
            {/* Rank badge */}
            {rank && (
              <div className="flex-shrink-0">
                <span className={`inline-flex items-center justify-center w-8 h-8 rounded-full text-white text-sm font-bold ${
                  rank === 1 ? 'bg-yellow-500' : rank === 2 ? 'bg-gray-400' : rank === 3 ? 'bg-amber-600' : 'bg-blue-600'
                }`}>
                  {rank}
                </span>
              </div>
            )}
            
            {/* Logo */}
            <a 
              href={casino.url} 
              target="_blank" 
              rel="noopener noreferrer"
              onClick={() => trackOutboundClick(casino.url, casino.name)}
              className="flex-shrink-0"
            >
              <img 
                src={casino.logo} 
                alt={casino.name}
                className="w-16 h-16 object-contain"
                onError={(e) => {
                  e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='64' height='64'%3E%3Crect fill='%23f3f4f6' width='64' height='64' rx='8'/%3E%3C/svg%3E";
                }}
              />
            </a>
            
            {/* Info */}
            <div className="flex-1 min-w-0">
              <a 
                href={casino.url} 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={() => trackOutboundClick(casino.url, casino.name)}
                className="font-bold text-gray-900 hover:text-blue-600"
              >
                {casino.name}
              </a>
              <p className="text-sm text-gray-500 mt-1">Dépôt min: {casino.minDeposit || '10€'}</p>
            </div>
            
            {/* Score */}
            <div className="flex-shrink-0">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-red-500 to-red-600 flex items-center justify-center shadow-lg">
                <span className="text-white font-bold text-sm">{casino.rating}</span>
              </div>
            </div>
          </div>
          
          {/* Bonus */}
          <div className="mt-4 p-3 bg-gray-50 rounded-lg">
            <p className="text-xs text-gray-500 uppercase font-semibold mb-1">Offre de bienvenue</p>
            <p className="font-bold text-gray-900">{casino.mainBonus}</p>
            {casino.secondaryBonus && (
              <p className="text-sm text-gray-600 mt-1">{casino.secondaryBonus}</p>
            )}
          </div>
          
          {/* CTA Button */}
          <a 
            href={casino.url} 
            target="_blank" 
            rel="noopener noreferrer"
            onClick={() => trackOutboundClick(casino.url, casino.name)}
            className="mt-4 block w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg text-center transition-colors"
          >
            VOIR L'OFFRE
          </a>
          
          {/* Terms */}
          <p className="text-xs text-gray-400 mt-3 text-center">
            18+ | T&C s'appliquent | Jouez responsable
          </p>
        </div>
        
        {/* Desktop Layout */}
        <div className="hidden md:grid md:grid-cols-12 gap-4 items-center">
          {/* Rank + Logo + Name */}
          <div className="col-span-3 flex items-center space-x-3">
            {rank && (
              <span className={`inline-flex items-center justify-center w-8 h-8 rounded-full text-white text-sm font-bold flex-shrink-0 ${
                rank === 1 ? 'bg-yellow-500' : rank === 2 ? 'bg-gray-400' : rank === 3 ? 'bg-amber-600' : 'bg-blue-600'
              }`}>
                {rank}
              </span>
            )}
            <a 
              href={casino.url} 
              target="_blank" 
              rel="noopener noreferrer"
              onClick={() => trackOutboundClick(casino.url, casino.name)}
              className="flex items-center space-x-3 hover:opacity-80 transition-opacity"
            >
              <img 
                src={casino.logo} 
                alt={casino.name}
                className="w-14 h-14 object-contain"
                onError={(e) => {
                  e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56' height='56'%3E%3Crect fill='%23f3f4f6' width='56' height='56' rx='8'/%3E%3C/svg%3E";
                }}
              />
              <span className="font-semibold text-gray-900">{casino.name}</span>
            </a>
          </div>
          
          {/* Min Deposit */}
          <div className="col-span-2 text-center">
            <span className="inline-block bg-gray-100 px-3 py-1 rounded-full text-sm font-medium text-gray-700">
              {casino.minDeposit || '10€'}
            </span>
          </div>
          
          {/* Bonus Info */}
          <div className="col-span-5">
            <p className="font-bold text-gray-900">{casino.mainBonus}</p>
            {casino.secondaryBonus && (
              <p className="text-sm text-gray-500 mt-1">{casino.secondaryBonus}</p>
            )}
          </div>
          
          {/* Score */}
          <div className="col-span-1 flex justify-center">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-red-500 to-red-600 flex items-center justify-center shadow-lg">
              <span className="text-white font-bold">{casino.rating}</span>
            </div>
          </div>
          
          {/* CTA Button */}
          <div className="col-span-1">
            <a 
              href={casino.url} 
              target="_blank" 
              rel="noopener noreferrer"
              onClick={() => trackOutboundClick(casino.url, casino.name)}
              className="block bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-3 rounded-lg text-center text-sm transition-colors whitespace-nowrap"
            >
              VOIR L'OFFRE
            </a>
          </div>
        </div>
      </div>
      
      {/* Bottom bar with terms - Desktop only */}
      <div className="hidden md:block bg-gray-50 px-4 py-2 rounded-b-lg border-t">
        <p className="text-xs text-gray-400">
          18+ | {casino.authorized || 'ANJ'} | T&C s'appliquent | Jouez responsable
        </p>
      </div>
    </div>
  );
};

export default CasinoCard;
